// Encaixe do painel do chat dentro de uma página (área Conversas da página Assistentes, D-OP-19).
// A MESMA instância do ChatLauncher desenha o painel no elemento registrado aqui: um polling, um som,
// um contador — duas instâncias duplicariam tudo isso.
export const CHAT_DOCK_EVENT = "clinic4us:chat-dock";

export const chatDockStore: { element: HTMLElement | null } = { element: null };

export const setChatDock = (element: HTMLElement | null) => {
  chatDockStore.element = element;
  window.dispatchEvent(new CustomEvent(CHAT_DOCK_EVENT, { detail: { element } }));
};

// App Assistentes (modal em tela cheia por cima de qualquer página): abrir pelo menu ou por código, e
// avisar quem precisa sumir enquanto ele está aberto (o FAB do chat).
export const OPEN_ASSISTANTS_EVENT = "clinic4us:open-assistants";
export const ASSISTANTS_STATE_EVENT = "clinic4us:assistants-state";

export const assistantsStore: { open: boolean } = { open: false };

export const openAssistants = (area?: string) =>
  window.dispatchEvent(new CustomEvent(OPEN_ASSISTANTS_EVENT, { detail: { area } }));

export const setAssistantsOpen = (open: boolean) => {
  assistantsStore.open = open;
  window.dispatchEvent(new CustomEvent(ASSISTANTS_STATE_EVENT, { detail: { open } }));
};
